import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useLocation, useParams } from 'react-router'
import Select, { SingleValue } from 'react-select'
import Pages from './SelfServe.pages'
import { Routes } from '../../constants'

interface SelfServeRouteParams {
    estate: string;
    page: string;
}

interface SelectOption {
    value: string;
    label: string;
    isActive: boolean;
    isDisabled: boolean;
}

export default function HeaderMobile() {
    const { t } = useTranslation()
    const { estate } = useParams<SelfServeRouteParams>()
    const { pathname } = useLocation()
    const history = useHistory()

    const options: SelectOption[] = React.useMemo(() => Pages.map(({ path, icon, isDisabled, i18nKey }) => {
        const builtPath = Routes.buildRoute(path, { estate })
        const isActive = pathname.includes(builtPath)

        return {
            value: builtPath,
            label: t(i18nKey),
            isActive,
            isDisabled,
        }
    }), [estate, pathname, t])

    const onClickOption = (option: SingleValue<SelectOption>) => {
        if (!option) {
            return
        }

        if (option.isDisabled) {
            return
        }

        history.push(Routes.buildRoute(option.value, { estate }))
    }

    return (
        <Select
            options={options}
            isOptionDisabled={(option) => option.isDisabled}
            onChange={onClickOption}
            value={options.find(option => option.isActive)}
            isSearchable={false}
            styles={{
                control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderWidth: 0,
                    boxShadow: 'none',
                    justifyContent: 'center',
                }),
                dropdownIndicator: (baseStyles, state) => ({
                    ...baseStyles,
                    //   display: 'none',
                }),
                indicatorSeparator: (baseStyles, state) => ({
                    ...baseStyles,
                    display: 'none',
                }),
                input: (provided) => ({
                    ...provided,
                    width: 'auto',
                    flex: '0 0 auto', // Prevents it from stretching
                    margin: 0,
                    padding: 0,
                }),
                valueContainer: (baseStyles) => ({
                    ...baseStyles,
                    display: 'flex',
                    flexWrap: 'nowrap',
                    flex: '0 0 auto', // Prevents it from stretching
                    gap: '4px', // Optional: Adds spacing between selected value and input
                }),
                container: (baseStyles) => ({
                    ...baseStyles,
                }),
                singleValue: (baseStyles) => ({
                    ...baseStyles,
                    width: 'auto',
                }),
                menu: (baseStyles) => ({
                    ...baseStyles,
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: 'auto',
                }),
                option: (baseStyles) => ({
                    ...baseStyles,
                    fontSize: '18px',
                    padding: '16px 24px',
                    fontWeight: 500,
                }),
            }}
        />
    )
}
